import yup from 'core/utils/validators';

const { object, string, boolean } = yup;

export const phoneVerificationFormSchema = () =>
  object().shape({
    confirmation_code: string()
      .min(4, 'message_confirmation_code_length')
      .required('message_confirmation_code_required'),
    is_data_processing_consent_given: boolean(),
    is_credit_bureau_consent_given: boolean(),
  });
